const Contact = () => {
  return (
    <div>
        <h1>Contact US</h1>
    </div>
  )
}

export default Contact